// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1GKCP","head":"ProcedureTableInfo_head__1frP_"};